export default {
	name: 'Home',
	path: '',
	meta: {
		public: true
	}
}